import { Component, OnInit, ViewChild } from '@angular/core';
import { ViewRequestsRecognitionComponent } from '../view-requests-recognition/view-requests-recognition.component';
import { ReportsService } from '../shared/reports.service';
import { RequestRecognition } from '../shared/request-recognition.model';
import { FilterRequestRecon } from '../shared/filter-request-recon.model';
import {  MatTabChangeEvent } from '@angular/material';
import { Role } from '../../requets/shared/model/Role.model';
import { BossDependence } from '../../requets/shared/model/boss-dependence.model';
import { UserService } from '../../requets/shared/user.service';
import { RoleInformation } from 'src/app/core/shared/role-information.model';
import { UtilityService } from 'src/app/core/shared/utility.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-requests-recognition',
  templateUrl: './requests-recognition.component.html',
  styleUrls: ['./requests-recognition.component.scss']
})
export class RequestsRecognitionComponent implements OnInit {

  rolVicedecano: String = 'maresVicedecano';
  rolJefeDepto: String = 'maresJefeDeptoAcad';
  rolCoordinador: String = 'maresCOORIDIOMASRECON';
  requestsI: RequestRecognition[];
  requestsP: RequestRecognition[];
  requestsR: RequestRecognition[];
  requestsA: RequestRecognition[];
  requestsS: RequestRecognition[];
  estado: String = 'I';
  enabledSpinner = false;
  roles: Role[] = [];
  rolesApplication: Role[] = [];
  tipoRol: number;
  bossDeependence: BossDependence;
  currentRol: Role;
  filter: FilterRequestRecon;
  @ViewChild (ViewRequestsRecognitionComponent) viewRequestsRecognitionComponent: ViewRequestsRecognitionComponent;

  constructor(private reportService: ReportsService,
              private userService: UserService,
              private utilityService: UtilityService,
              private router: Router) { }

  ngOnInit() {
      this.getUserInformation();
  }

  refreshSearch() {
    this.sendFilter(this.filter);
  }

  changeSpinner(estado: boolean) {
    this.enabledSpinner = estado;
  }

  getListRequestsRecognition(filterRequest: FilterRequestRecon) {
    filterRequest.usuario = localStorage.getItem('cedula');
    this.reportService.getRequestRecognition(filterRequest).subscribe(
      (result) => {
        if (result.data) {
            if (this.estado === 'I') {
              this.requestsI = result.data as RequestRecognition[];
            } else if (this.estado === 'P') {
              this.requestsP = result.data as RequestRecognition[];
            } else if (this.estado === 'R') {
              this.requestsR = result.data as RequestRecognition[];
            } else if (this.estado === 'A') {
              this.requestsA = result.data as RequestRecognition[];
            } else if (this.estado === 'S') {
              this.requestsS = result.data as RequestRecognition[];
            }

        }
        this.enabledSpinner = false;
      }
    );
  }

  sendFilter(event: FilterRequestRecon) {
    this.filter = event;
    event.estado = this.estado;
    this.enabledSpinner = true;
    this.getListRequestsRecognition(event);
    this.viewRequestsRecognitionComponent.messageError = '';
  }

  selectTabChange(event: MatTabChangeEvent) {
    if (event.index === 0) {
      this.estado = 'I';
    } else if (event.index === 1) {
      this.estado = 'P';
    } else if (event.index === 2) {
      this.estado = 'R';
    } else if ( event.index === 3) {
      this.estado = 'A';
    } else if (event.index === 4) {
      this.estado = 'S';
    }

    this.sendFilter(this.filter);
  }

  private getUserInformation() {
    const userid =  null;
    const cedula =  localStorage.getItem('cedula');
    this.userService.getUserInformation(userid, cedula).subscribe(
      (result) => {
        if (result.data) {
            this.roles =  result.data.roles as Role[];
            this.bossDeependence = result.data.jefeDepartamento as BossDependence;
             const roleInformation: RoleInformation = this.utilityService.validateRole(this.roles, 2);
             this.rolesApplication = roleInformation.roles;
             this.currentRol = roleInformation.currentRol;
             this.tipoRol = roleInformation.tipoValidation;
             if (this.tipoRol  === 0) {
              const parameters = {
                tipo: 'info',
                mensaje: 'Usted no posee el rol adecuado para acceder a esta opción'
              };
              this.router.navigate(['message'], {queryParams : parameters});
             }
             this.requestsA = [];
             this.requestsI = [];
             this.requestsP = [];
             this.requestsR = [];
             this.requestsS = [];
             this.enabledSpinner = false;

        }
      }
    );
  }

}
